import React, { useState, useEffect, useCallback } from 'react';
import { axios } from '@/lib/axios';
import { DashboardProps } from '@/containers/dashboard/Dashboard';
import {useLoadingStore} from '@/stores/loading';
import {useMessageModalStore} from '@/stores/message'
import DashboardCard from './DashboardCard';
import * as Config from '@/config'

interface SummaryData {
  name?: string;
  count: number;
}

const ServiceStart: React.FC<DashboardProps> = ({ projectId, startDate, endDate }) => {
  const setLoading = useLoadingStore(state => state.setLoading);
  const setMessage = useMessageModalStore(state => state.setMessage);

  const [summaryServiceStart, setSummaryServiceStart] = useState<SummaryData[]>([]);

  const fetchData = useCallback(async (projectCategoryId: number): Promise<SummaryData[]> => {
    const response = await axios.get(`/api/v1/dashboard/areaSummary`, {
      params: {
        project_id: projectId,
        project_category_id: projectCategoryId,
        start_date: startDate,
        end_date: endDate,
      },
    });
    return response.data.summary;
  }, [projectId, startDate, endDate]);

  useEffect(() => {
    const loadAllData = async () => {
      setLoading(true);
      try {
        const [serviceStartData] = await Promise.all([
          fetchData(Config.PROJECT_CATEGORY_ID_SERVICE_START_INFO),
        ]);

        setSummaryServiceStart(serviceStartData);

      } catch (err) {
        setMessage(Config.MESSAGE_NO_E39);
      } finally {
        setLoading(false);
      }
    };

    loadAllData();
  }, [fetchData, setLoading]);

  return (
    <div className="dashboard-grid">
      {summaryServiceStart.length > 0 &&
        <DashboardCard title='地整毎の供用開始の登録数'>
          <table>
            <tbody>
              {summaryServiceStart.map((summary, index) => (
                <tr key={`${summary.name}_${index}`}>
                  <td>{summary.name}</td>
                  <td>{`${summary.count}件`}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </DashboardCard>
      }
    </div>
  );
};

export default ServiceStart;